import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { INITIATE_TAP_ONBOARDING } from "helpers/url_helper";
import { post } from "helpers/api_helper";
import getAccessToken from "helpers/accessToken";

// ✅ Initiate Merchant Onboarding
export const initiateTapOnboarding = createAsyncThunk(
  INITIATE_TAP_ONBOARDING,
  async (payload) => {
    const { token } = getAccessToken();
    const response = await post(INITIATE_TAP_ONBOARDING, payload, {
      headers: { authorization: token },
    });
    return response;
  },
);

const tapOnboardingSlice = createSlice({
  name: "tapOnboarding",

  initialState: {
    loading: false,
    onboardingLink: null,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(initiateTapOnboarding.pending, (state) => {
        state.loading = true;
      })

      .addCase(initiateTapOnboarding.fulfilled, (state, action) => {
        state.loading = false;
        state.onboardingLink = action.payload?.onboarding_url;
      })

      .addCase(initiateTapOnboarding.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default tapOnboardingSlice.reducer;
